// extracted by mini-css-extract-plugin
module.exports = {"input":"Item_input__1My58","form":"Item_form__3Tppc","pencil":"Item_pencil__3ws83"};